import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import { VehicleEnumsContainer } from "./containers/VehicleEnumsContainer";

const routes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<VehicleEnumsContainer />}
          permissions={[Permission.ADMIN_GLOBAL_ENUMERATIONS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
